<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<div>
			<div class="item-filters">
				<div slot="header" class="w-full mb-12 flex" style="align-items: center;">
					<div class="flex flex-grow justify-start flex-wrap" :key="upCompany">
						<div class="md:flex lg:flex xl:flex vs-con-loading__container" :key="idxStatus" v-for="(statusLabel, idxStatus) in companies">
							<div class="md:flex lg:flex xl:flex mr-3 mb-3">
								<vs-button title="Tìm theo khớp giá" class="w-36 font-bold custom-button" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByCompany(statusLabel.id)">{{statusLabel.name}}</vs-button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<vs-row class="mb-5">
				<vs-col vs-lg="3" vs-sm="12" style="display: flex; vertical-align: middle;" class="">
					<div class="w-full menu-overview-com" style="overflow: auto;">
						<div style="width: 6px; height: 96px; background: #027EBA; border-radius: 41px; position: absolute; top: 0; left: 0;"></div>
						<label style="color: #000; font-size: 20px; font-weight: 600; margin-top: 6px; margin-left: 18px; display: block; white-space: nowrap;">{{ activeCongTy.name }}</label>
						<div style="background: #282828; border-radius: 55px; height: 33px; width: 180px; margin-top: 18px; margin-left: 18px; display: flex; justify-content: center; align-items: center;">
							<!-- <label style="color: #fff; font-size: 16px; font-weight: 600;">{{ $helper.momentFormat(activeTime, 'HH:mm DD/MM/YY') }}</label> -->
							<CbsDatePicker value-format="yyyy-MM-dd" name="activeTime" :data-vv-as="'Thời gian'" class="w-full" v-model="activeTime2" type="date" placeholder="Chọn ngày giao" :picker-options="pickerOptions" />
						</div>
					</div>
				</vs-col>
				<vs-col vs-lg="3" vs-sm="12" style="display: flex; vertical-align: middle;">
					<div class="w-full menu-overview-com ml-5 flex flex-grow justify-start flex-wrap">
						<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
							<g clip-path="url(#clip0_1302_1506)">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M6.49977 8.66663C6.14589 8.66685 5.79745 8.75375 5.4849 8.91973C5.17236 9.08572 4.90523 9.32573 4.70687 9.61879C4.5085 9.91185 4.38494 10.249 4.34697 10.6009C4.30901 10.9527 4.35781 11.3085 4.4891 11.6371L8.66644 22.0848V39C8.66644 40.1492 9.12298 41.2514 9.93564 42.0641C10.7483 42.8767 11.8505 43.3333 12.9998 43.3333H41.1664C42.3157 43.3333 43.4179 42.8767 44.2306 42.0641C45.0432 41.2514 45.4998 40.1492 45.4998 39V21.8811L47.6231 11.258C47.6859 10.9437 47.6782 10.6195 47.6006 10.3086C47.523 9.99772 47.3775 9.70791 47.1744 9.46006C46.9713 9.2122 46.7157 9.01248 46.4262 8.87528C46.1366 8.73808 45.8202 8.66682 45.4998 8.66663H36.8331C36.3324 8.66693 35.8473 8.84064 35.4602 9.15821C35.0731 9.47579 34.8079 9.91764 34.7098 10.4086L33.9731 14.0941L32.3438 10.0295C32.1831 9.62741 31.9058 9.2827 31.5474 9.03979C31.189 8.79687 30.7661 8.6669 30.3331 8.66663H6.49977ZM25.9998 32.5C25.4251 32.5 24.874 32.7282 24.4677 33.1346C24.0614 33.5409 23.8331 34.092 23.8331 34.6666C23.8331 35.2413 24.0614 35.7924 24.4677 36.1987C24.874 36.605 25.4251 36.8333 25.9998 36.8333H28.1664C28.7411 36.8333 29.2922 36.605 29.6985 36.1987C30.1048 35.7924 30.3331 35.2413 30.3331 34.6666C30.3331 34.092 30.1048 33.5409 29.6985 33.1346C29.2922 32.7282 28.7411 32.5 28.1664 32.5H25.9998Z" fill="#F5BE2E"/>
							</g>
							<defs>
								<clipPath id="clip0_1302_1506">
								<rect width="52" height="52" fill="white"/>
								</clipPath>
							</defs>
						</svg>
						<div style="display: flex; width: calc(100% - 64px); padding-top: 17px; padding-left: 17px;">
							<vs-col vs-lg="6" vs-sm="6">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">Chờ kiểm</label>
								<label style="color: #000; font-size: 32px; font-weight: 700;">{{ $helper.numFormat(tongQuan.sl_cho_kiem || 0) }} <label style="font-size: 16px;">đơn</label></label>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="6" class="text-right">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">&nbsp;</label>
								<label style="color: #000; font-size: 32px; font-weight: 700; margin-right: 16px;">{{ $helper.numFormat(tongQuan.kl_cho_kiem || 0) }} <label style="font-size: 16px;">tấn</label></label>
							</vs-col>
						</div>
						<div style="width: 91px; height: 30px; background: #F5BE2E; border-radius: 0px 0px 0px 20px; position: absolute; top: 0; right: 0; display: flex; justify-content: center; align-items: center;">
							<label style="color: #FFF; font-size: 16px; font-weight: 400;">{{ Number.parseFloat((tongQuan.sl_cho_kiem || 0) / (tongQuan.tong_sum || 1) * 100).toFixed(1) }}%</label>
						</div>
					</div>
				</vs-col>


				<vs-col vs-lg="3" vs-sm="12" style="display: flex; vertical-align: middle;">
					<div class="w-full menu-overview-com ml-5 flex flex-grow justify-start flex-wrap">
						<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
							<path d="M45.8778 20.8853C45.112 20.085 44.3198 19.2603 44.0213 18.5352C43.745 17.8709 43.7287 16.77 43.7125 15.7036C43.682 13.7211 43.6495 11.4745 42.0875 9.9125C40.5255 8.35047 38.2789 8.31797 36.2964 8.2875C35.23 8.27125 34.1291 8.255 33.4648 7.97875C32.7417 7.68016 31.915 6.88797 31.1147 6.12219C29.7131 4.77547 28.1206 3.25 26 3.25C23.8794 3.25 22.2889 4.77547 20.8853 6.12219C20.085 6.88797 19.2603 7.68016 18.5352 7.97875C17.875 8.255 16.77 8.27125 15.7036 8.2875C13.7211 8.31797 11.4745 8.35047 9.9125 9.9125C8.35047 11.4745 8.32812 13.7211 8.2875 15.7036C8.27125 16.77 8.255 17.8709 7.97875 18.5352C7.68016 19.2583 6.88797 20.085 6.12219 20.8853C4.77547 22.2869 3.25 23.8794 3.25 26C3.25 28.1206 4.77547 29.7111 6.12219 31.1147C6.88797 31.915 7.68016 32.7397 7.97875 33.4648C8.255 34.1291 8.27125 35.23 8.2875 36.2964C8.31797 38.2789 8.35047 40.5255 9.9125 42.0875C11.4745 43.6495 13.7211 43.682 15.7036 43.7125C16.77 43.7287 17.8709 43.745 18.5352 44.0213C19.2583 44.3198 20.085 45.112 20.8853 45.8778C22.2869 47.2245 23.8794 48.75 26 48.75C28.1206 48.75 29.7111 47.2245 31.1147 45.8778C31.915 45.112 32.7397 44.3198 33.4648 44.0213C34.1291 43.745 35.23 43.7287 36.2964 43.7125C38.2789 43.682 40.5255 43.6495 42.0875 42.0875C43.6495 40.5255 43.682 38.2789 43.7125 36.2964C43.7287 35.23 43.745 34.1291 44.0213 33.4648C44.3198 32.7417 45.112 31.915 45.8778 31.1147C47.2245 29.7131 48.75 28.1206 48.75 26C48.75 23.8794 47.2245 22.2889 45.8778 20.8853ZM35.2747 22.2747L23.8997 33.6497C23.7488 33.8008 23.5695 33.9206 23.3723 34.0024C23.175 34.0842 22.9636 34.1263 22.75 34.1263C22.5364 34.1263 22.325 34.0842 22.1277 34.0024C21.9305 33.9206 21.7512 33.8008 21.6003 33.6497L16.7253 28.7747C16.4204 28.4698 16.2491 28.0562 16.2491 27.625C16.2491 27.1938 16.4204 26.7802 16.7253 26.4753C17.0302 26.1704 17.4438 25.9991 17.875 25.9991C18.3062 25.9991 18.7198 26.1704 19.0247 26.4753L22.75 30.2027L32.9753 19.9753C33.1263 19.8243 33.3055 19.7046 33.5028 19.6229C33.7001 19.5412 33.9115 19.4991 34.125 19.4991C34.3385 19.4991 34.5499 19.5412 34.7472 19.6229C34.9445 19.7046 35.1237 19.8243 35.2747 19.9753C35.4257 20.1263 35.5454 20.3055 35.6271 20.5028C35.7088 20.7001 35.7509 20.9115 35.7509 21.125C35.7509 21.3385 35.7088 21.5499 35.6271 21.7472C35.5454 21.9445 35.4257 22.1237 35.2747 22.2747Z" fill="#63BA46"/>
						</svg>
						<div style="display: flex; width: calc(100% - 64px); padding-top: 17px; padding-left: 17px;">
							<vs-col vs-lg="6" vs-sm="6">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">Đạt</label>
								<label style="color: #000; font-size: 32px; font-weight: 700;">{{ $helper.numFormat(tongQuan.sl_dat || 0) }} <label style="font-size: 16px;">đơn</label></label>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="6" class="text-right">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">&nbsp;</label>
								<label style="color: #000; font-size: 32px; font-weight: 700; margin-right: 16px">{{ $helper.numFormat(tongQuan.kl_dat || 0) }} <label style="font-size: 16px;">tấn</label></label>
							</vs-col>
						</div>
						<div style="width: 91px; height: 30px; background: #63BA46; border-radius: 0px 0px 0px 20px; position: absolute; top: 0; right: 0; display: flex; justify-content: center; align-items: center;">
							<label style="color: #FFF; font-size: 16px; font-weight: 400;">{{ Number.parseFloat((tongQuan.sl_dat || 0) / (tongQuan.tong_sum || 1) * 100).toFixed(1) }}%</label>
						</div>
					</div>
				</vs-col>

				<vs-col vs-lg="3" vs-sm="12" style="display: flex; vertical-align: middle;">
					<div class="w-full menu-overview-com ml-5 flex flex-grow justify-start flex-wrap">
						<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
							<path d="M25.9998 4.33337L8.6665 10.8334V24.0284C8.6665 34.97 16.0548 45.175 25.9998 47.6667C35.9448 45.175 43.3332 34.97 43.3332 24.0284V10.8334L25.9998 4.33337ZM33.5832 30.5284L30.5282 33.5834L25.9998 29.0767L21.4715 33.5834L18.4165 30.5284L22.9448 26L18.4165 21.4717L21.4715 18.4167L25.9998 22.945L30.5282 18.4167L33.5832 21.4717L29.0765 26L33.5832 30.5284Z" fill="#DE0000"/>
						</svg>
						<div style="display: flex; width: calc(100% - 64px); padding-top: 17px; padding-left: 17px;">
							<vs-col vs-lg="6" vs-sm="6">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">Không đạt</label>
								<label style="color: #000; font-size: 32px; font-weight: 700;">{{ $helper.numFormat(tongQuan.sl_khong_dat || 0) }} <label style="font-size: 16px;">đơn</label></label>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="6" class="text-right">
								<label style="color: #000; font-size: 16px; font-weight: 400; display: block; margin-bottom: 8px;">&nbsp;</label>
								<label style="color: #000; font-size: 32px; font-weight: 700; margin-right: 16px">{{ $helper.numFormat(tongQuan.kl_khong_dat || 0) }} <label style="font-size: 16px;">tấn</label></label>
							</vs-col>
						</div>
						<div style="width: 91px; height: 30px; background: #DE0000; border-radius: 0px 0px 0px 20px; position: absolute; top: 0; right: 0; display: flex; justify-content: center; align-items: center;">
							<label style="color: #FFF; font-size: 16px; font-weight: 400;">{{ Number.parseFloat((tongQuan.sl_khong_dat || 0) / (tongQuan.tong_sum || 1) * 100).toFixed(1) }}%</label>
						</div>
					</div>
				</vs-col>
			</vs-row>

			<vs-row>
				<vs-col vs-lg="7" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
					<div class="w-full menu-title-com mr-2">
						Danh sách đăng tài
					</div>
				</vs-col>
				<vs-col vs-lg="5" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
					<div class="w-full menu-title-com ml-2">
						Chi tiết vận đơn
					</div>
				</vs-col>
			</vs-row>

			<vs-row class="mt-2">
				<vs-col vs-lg="7" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
					<div class="w-full menu-content-com mr-2">
						<div class="item-filters">
							<div slot="header" class="w-full mb-12 flex" style="align-items: center;">
								<div class="flex flex-grow justify-start flex-wrap" :key="upStatus">
									<div class="md:flex lg:flex xl:flex vs-con-loading__container" :key="`${upStatus}--1`">
										<div class="md:flex lg:flex xl:flex mr-3 mb-3">
											<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="'#000960'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
										</div>
									</div>
									<div class="md:flex lg:flex xl:flex vs-con-loading__container" :key="idxStatus" v-for="(statusLabel, idxStatus) in statusList">
										<div class="md:flex lg:flex xl:flex mr-3 mb-3">
											<vs-button title="Tìm theo khớp giá" class="w-36 font-bold" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div>
							<table class="w-full custom-table" :key="upTable">
								<thead>
									<tr>
										<th style="padding-left: 22px;">STT</th>
										<th>Thời gian</th>
										<th>Mã VĐ</th>
										<th >Biển số</th>
										<th>Mặt hàng</th>
										<th>NCC/KH</th>
										<th>KL (kg)</th>
										<th>Trạng thái</th>
									</tr>
								</thead>
								<tbody>
									<tr :key="idx" v-for="(shipping, idx) in shippings" :set="statusDirective = $helper.getStatusAndColorNhatKy(shipping)" style="cursor: pointer;" @click="changeActiveVanDon(idx)" :style="{backgroundColor: activeIndexVanDon == idx ? 'rgba(2, 126, 186, 0.10)' : '#fff'}">
										<td style="position: relative;">
											<div class="custom-pin" :style="{backgroundColor: statusDirective.color}">

											</div>
											<p class="word-break text-left uppercase" style="padding-left: 20px;">
												{{ shipping.stt || (idx + 1) }}
											</p>
										</td>
										<td>
											<p class="word-break text-left">
												{{ $helper.momentFormat(shipping.shipping_date, 'HH:mm') }}
											</p>
										</td>
										<td>
											<p class="word-break text-left uppercase">
												{{ shipping.code }}
											</p>
										</td>
										<td>
											<p class="word-break text-left uppercase">
												{{ shipping.vehicle_no }}
											</p>
										</td>
										<td>
											<p class="word-break text-left">
												{{ shipping.matching ? (shipping.matching.product ? shipping.matching.product.name : '-') : '-' }}
											</p>
										</td>
										<td>
											<p class="word-break text-left">
												{{ shipping.matching ? shipping.matching.supplier_name : '-' }}
											</p>
										</td>
										<td>
											<p class="word-break text-left">
												{{ $helper.numFormat(shipping.quantity) }}
											</p>
										</td>
										<td>
											<p class="word-break text-left">
												<label class="text-default" :style="{color: statusDirective.color}">
													{{ statusDirective.name}}
												</label>
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="w-full center mt-4">
							<CbsPagination :total="total" v-model="page"></CbsPagination>
						</div>
					</div>
				</vs-col>
				<vs-col vs-lg="5" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
					<div class="w-full menu-content-com ml-2">
						<div v-if="activeVanDon">
							<vs-row>
								<vs-col vs-lg="7" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500;">NCC/KH</label>
									</div>
								</vs-col>
								<vs-col vs-lg="5" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-right">
										<label style="color: #999; font-size: 12px; font-weight: 500;">Mã vận đơn: <label style="color: #000;">{{ activeVanDon.code }}</label> </label>
									</div>
								</vs-col>
							</vs-row>
							<vs-row>
								<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #000; font-size: 20px; font-weight: 600;">{{ activeVanDon.matching ? activeVanDon.matching.supplier_name : '-' }}</label>
									</div>
								</vs-col>
							</vs-row>
							<vs-row :set="statusDirective = $helper.getStatusAndColorNhatKy(activeVanDon)">
								<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Mặt hàng</label>
										<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.matching ? (activeVanDon.matching.product ? activeVanDon.matching.product.name : '-') : '-' }}</label>
									</div>
								</vs-col>
								<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Đánh giá vận đơn</label>
										<div class="flex">
											<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 1) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
											<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 2) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
											<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 3) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
											<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 4) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
											<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 5) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
										</div>
									</div>
								</vs-col>
								<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Trạng thái</label>
										<label :style="{color: statusDirective.color, 'font-size': '16px', 'font-weight': 500}">{{ statusDirective.name }}</label>
									</div>
								</vs-col>
							</vs-row>
							<vs-row>
								<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Người đánh giá</label>
										<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.voter ? activeVanDon.voter.name : '-' }}</label>
									</div>
								</vs-col>
								<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5" v-if="activeVanDon.humidity">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Độ ẩm</label>
										<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.humidity }}</label>
									</div>
								</vs-col>
							</vs-row>
							<vs-row>
								<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Nội dung đánh giá</label>
										<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.kcs_note ? activeVanDon.kcs_note : 'Chưa có' }}</label>
									</div>
								</vs-col>
							</vs-row>
							<vs-row>
								<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
									<div class="w-full text-left">
										<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Hình ảnh KCS cung cấp </label>
									</div>
								</vs-col>
							</vs-row>
							<div class="flex flex-grow justify-start flex-wrap">
								<div class="text-left" style="height: 100%; max-height: 360px; width: calc(100% - 60px);">
									<img :src="activeImage ? activeImage.path : 'https://spp.agriindex.vn/storage/app/media/assets/images/noimg2.jpg'" style="width: 100%; max-height: 360px; object-fit: cover; overflow: hidden;" />
								</div>
								<div>
									<div :key="idx" v-for="(photo, idx) in activeVanDon.photos2" style="margin-left: 20px; margin-bottom: 10px;" @click="changeImageIndex(idx)">
										<div class="w-full text-left" style="cursor: pointer;">
											<img :src="photo.path" style="border-radius: 5px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25); width: 40px; height: 40px;" :style="{border: activeImageIndex == idx ? '2px solid #057FBB' : 'none'}" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</div>
		<OrderForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import moment from "moment";

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm,
		CbsDatePicker
	},
	data() {
		return {
			pickerOptions: {
				
			},
			activeTime2: moment().format('YYYY-MM-DD'),
			// activeCongTy: {id: 46, name: 'Công ty TNHH Cỏ May Sa Đéc', active: 1},
			activeCongTy: {},
			activeTime: Date.now(),
			shippings: [],
			activeVanDon: null,
			activeIndexVanDon: 0,
			activeImage: null,
			activeImageIndex: 0,
			companies: [
				// {id: 46, name: 'Công ty TNHH Cỏ May Sa Đéc', active: 1},
				// {id: 285, name: 'Công ty Việt Mỹ Thanh Bình', active: 0},
				// {id: 'xuat_hang', name: 'Xuất hàng Cỏ May Sa Đéc', active: 0},
			],
			statusList: [
				{id: 1, name: 'Chờ kiểm'},
				{id: 2, name: 'Đạt'},
				{id: 3, name: 'Không đạt'}
			],
			customLimit: 20,
			productList: [],
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now(),
			upCompany: Date.now(),
			upTable: Date.now(),
			isAll: true,
			tongQuan: {},
			timeOut1: null,
			timeOut2: null,
			total: 0
		};
	},
	// computed: {
	// 	total() {
	// 		return Math.ceil(this.$store.state.moduleProduct.sellTotal / this.customLimit);
	// 	},
	// },
	methods: {
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		changeImageIndex(index) {
			this.activeImage = null;
			if (this.activeVanDon) {
				this.activeImageIndex = index;
				if (this.activeVanDon.photos2 && this.activeVanDon.photos2.length) {
					this.activeImage = this.activeVanDon.photos2[index];
				}
			}
		},
		changeActiveVanDon(index) {
			if (this.shippings) {
				this.activeIndexVanDon = index;
				this.activeVanDon = this.shippings[index];
				this.upTable = Date.now();
				this.changeImageIndex(0);
			}
		},
		filterByCompany(id) {
			this.companies.map((status, index) => {
				if (status.id == id) {
					status.active = true;
				} else {
					status.active = false;
				}
				if (status.active) {
					this.activeCongTy = status;
				}
			});
			this.upCompany = Date.now();
			this.page = 1; // reset page
			this.getShippings();
			this.getShippingsOverview();
		},
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getShippings();
		},
		async getShippingsOverview(auto = false) {
			if (this.timeOut1) {
				clearTimeout(this.timeOut1);
			}
			let companies = [];
			this.companies.map(status => {
				if (status.active) {
					companies.push(status.id);
				}
			});

			const payload = {
				id: 0,
				companies: companies,
				overview: 1,
				active_time: this.activeTime2
			};
			try {
				let shippings = await this.$store.dispatch("moduleProduct/fetchShippings", payload);
				this.tongQuan = shippings;
			} catch (error) {
				
			}
			this.timeOut1 = setTimeout(() => {
				this.getShippingsOverview(true);
			}, 31000);
		},
		async getShippings(auto = false) {
			if (this.timeOut2) {
				clearTimeout(this.timeOut2);
			}
			this.activeTime = Date.now();
			if (!auto) {
				this.activeImageIndex = 0;
				this.activeImage = null;
				this.$vs.loading();
			}

			let companies = [];
			this.companies.map(status => {
				if (status.active) {
					companies.push(status.id);
				}
			});
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			this.filters.statuses = !isAll ? statuses : [];
			this.filters.companies = companies;

			const payload = {
				is_new: 1,
				statuses: statuses,
				companies: companies,
				// filters: this.filters,
				id: 0,
				search: this.searchText,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				active_time: this.activeTime2
			};
			try {
				let shippings = await this.$store.dispatch("moduleProduct/fetchShippings", payload);
				let {data = [], total} = shippings;
				let finalData = [];
				if (data.length) {
					let data1 = [];
					let data2 = [];
					for (let i in data) {
						let item = data[i];
						item.stt = parseInt(i) + 1;
						if (item.tested_date && data1.length == 0) {
							data1.push(item);
						} else {
							data2.push(item);
						}
					}
					finalData = data1.concat(data2);

					if (this.activeVanDon == null || !auto) {
						this.activeIndexVanDon = 0;
						this.activeVanDon = finalData[this.activeIndexVanDon];
					}
					if (this.activeVanDon && this.activeVanDon.photos2 && this.activeVanDon.photos2.length) {
						if (this.activeImage == null) {
							this.activeImageIndex = 0;
							this.activeImage = this.activeVanDon.photos2[this.activeImageIndex];
						}
						// if (!auto) {
						// 	this.activeImageIndex = 0;
						// 	this.activeImage = this.activeVanDon.photos2[this.activeImageIndex];
						// }
					}
				}
				this.shippings = finalData;
				this.total = total ?Math.ceil( Number(total) / 10) : 1;
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
			this.timeOut2 = setTimeout(() => {
				this.getShippings(true);
			}, 29000);
		},

		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload).then(response => {
					let {data = []} = response;
					let productList = [
						// {
						// 	id: 0,
						// 	name: 'Tất cả',
						// 	active: 1,
						// 	color: 'primary',
						// },
					];
					if (data.length) {
						data.forEach (product => {
							productList.push(
								{
									id: product.id,
									name: product.name,
									active: 0,
									color: '#000000',
								}
							);
						})
					}
					this.productList = productList;
				})
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			this.productList.map(status => {
				if (status.active) {
					statuses.push(status.id);
				}
			});
			// console.log(this.productList);
			this.filters.statuses = statuses;
			const payload = {
				// filters: this.filters,
				pids: statuses,
				// id: 0,
				page: this.page,
				limit: this.customLimit,
				// sort: this.sort,
				// type: 'sv'
			};
			try {
				await this.$store.dispatch("moduleProduct/getSellsList", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				document.body.classList.remove("modal-open");
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getShippings();
		},
		searchText() {
			this.getShippings();
		},
		activeTime2() {
			this.activeTime = this.activeTime2;
			this.getShippings();
			this.getShippingsOverview();
		}
	},
	created() {
		// console.log(this.$store.state.AppActiveUser);
		let {company, id} = this.$store.state.AppActiveUser;
		let companies = [];
		if (id) {
			this.activeCongTy = {id: id, name: company, active: 1};
			companies.push({id: id, name: company, active: 1});
		}
		if (company == 'CÔNG TY TNHH CỎ MAY SA ĐÉC') {
			companies.push({id: 'xuat_hang', name: 'XUẤT HÀNG', active: 0});
		}
		this.companies = companies;
		this.upCompany = Date.now();
		this.getShippings();
		this.getShippingsOverview();
	},
};
</script>

<style lang="scss">
.menu-overview-com .el-input__inner {
	background: rgb(40, 40, 40);
    border-radius: 55px;
    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 600;
	padding-left: 0 !important;
	padding-right: 0 !important;
	text-align: center;
}
.menu-overview-com .el-input__prefix {
	opacity: 0;
}
.menu-overview-com .el-input__suffix {
	opacity: 0;
}

.custom-button .vs-button-text {
	text-transform: uppercase;
}
.vs-navbar.navbar-skelton {
    padding-left: 2.2rem !important;
}
.custom-nav-vertical {
	display: none !important;
	opacity: 0 !important;
}
.vs-button-primary {
	color: #282828 !important;
}
.vs-button-primary.vs-button-filled {
	background-color: #000960 !important;
	color: #FFF !important;
}
.vs-button-primary.vs-button-border {
	border: 1px solid #000960 !important;
}
.menu-overview-com {
	border-radius: 20px;
	background: #FFF;
	box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.10);
	height: 96px;
	position: relative;
	overflow: hidden;
	max-width: 400px;
}
.menu-overview-com svg {
	margin-top: 17px; margin-bottom: 27px; margin-left: 12px;
}
.custom-pin {
	width: 6px;
    height: 90%;
    position: absolute;
    border-radius: 52px;
    top: 0;
    left: 4px;
}
.custom-table {
	border-collapse: collapse;
}
.custom-table thead th {
	padding: 6px 0px;
}
.custom-table tbody tr {
	border-bottom: 3px solid #F3F3F3;
}
.custom-table tbody td {
	padding-top: 10px;
	padding-bottom: 10px;
}
.custom-table tbody tr:nth-child(1) td {
	font-weight: 600;
}

.menu-title-com {
	border-radius: 20px;
	background: #FFF;
	filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.10));
	text-align: center;
	padding: 13px;

	color: #282828;
	font-size: 15px;
	font-weight: 600;
}
.menu-content-com {
	border-radius: 20px;
	background: #FFF;
	box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.10);
	text-align: center;
	padding: 13px;
}
.item-filters {
	display: block;
}
.vx-navbar-wrapper {
	height: 80px !important;
}
.custom-wrap {
	width: 1410px;
	margin: auto;
}
.custom-dialog {
	z-index: 10001 !important;
}
.sell-trend-2 {
	position: absolute;
    width: 10px;
    height: 100%;
    top: -5px;
    left: 0px;
    z-index: 2;
	background: #FFFFFF;
}
.sell-trend {
	position: absolute;
	top: -10px;
	left: 0rem;
	background: #FFFFFF;
	padding: 5px 15px;
	box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.5);
}
.sell-box {
	background: #FFFFFF;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.sell-p-name {
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	/* identical to box height */


	color: #057FBB;
}
.sell-p-qty {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */

	text-align: right;

	color: rgba(0, 0, 0, 0.6);
}
.sell-p-price {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-p-ttl {
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	line-height: 12px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-p-ttv {
	font-style: normal;
	font-weight: 700;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */


	color: #000000;

}
.sell-p-ttt {
	font-style: normal;
	font-weight: 500;
	font-size: 8px;
	line-height: 10px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-img-box {
	width: 254px;
	height: 150px;
}
.sell-img-box img {
	object-fit: cover;
	width: 100%;
	height: 150px;
}
.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}

@media screen and (max-width: 600px) {
	.custom-wrap {
		width: 100%;
		margin: auto;
		justify-content: center !important;
	}

	.item-box {
		width: 90%;
	}
	.sell-img-box {
		width: 100%;
	}

	.item-filters {
		display: none !important;
	}
}

</style>
